import { useRef } from "react";
import { AuthModal } from "../index";
import { Field, Formik, Form } from "formik";
import { Button, Input } from "shared";
import * as Yup from "yup";
import { useLoginSuccessor, useGetSuccessor } from "hooks/successors";
import { VALIDATION_ENUM } from "enums";

interface LoginType {
  first?: boolean;
}

const Login = ({ first = false }: LoginType) => {
  const formRef = useRef<any>(null);
  const { refetch } = useGetSuccessor();

  const { mutate } = useLoginSuccessor({
    onSuccess: () => {
      refetch();
    },
  });

  const validation = () =>
    Yup.object().shape({
      email: Yup.string()
        .email(VALIDATION_ENUM.WRONG_EMAIL)
        .required(VALIDATION_ENUM.REQUIRED)
        .matches(
          /^[a-zA-Z0-9_%+-]+([.][a-zA-Z0-9_%+-]+)*@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
          VALIDATION_ENUM.WRONG_EMAIL
        ),
      password: Yup.string()
        .required(VALIDATION_ENUM.REQUIRED)
        .min(8, VALIDATION_ENUM.MIN_8),
    });

  const initialValues = {
    email: "",
    password: "",
  };

  const onSubmit = (values: typeof initialValues) => {
    const { email, password } = values;
    mutate({ email, password });
  };

  return (
    <AuthModal
      heading={
        first ? "Hasło zostało utworzone" : "Dostęp do zakładki „Sukcesja”"
      }
      paragraph={
        <>
          {first ? (
            <>
              Można teraz zalogować się do zakładki „Sukcesja”, podając
              utworzone hasło.
            </>
          ) : (
            <>
              Ze względów bezpieczeństwa dostęp do tej zakładki wymaga podania
              dodatkowego hasła utworzonego podczas pierwszej konfiguracji. W
              przypadku zapomnienia hasła, konieczny jest kontakt z
              administratorem w celu weryfikacji i uzyskania linku do jego
              zmiany.
            </>
          )}
        </>
      }
    >
      <Formik
        initialValues={initialValues}
        onSubmit={(values) => onSubmit(values)}
        validationSchema={validation()}
        innerRef={formRef}
      >
        {() => (
          <Form>
            <Field
              type="text"
              id="email"
              name="email"
              label={"E-mail"}
              as={Input}
            />{" "}
            <Field
              type="password"
              id="password"
              name="password"
              label={"Hasło"}
              as={Input}
            />
            <Button
              className="successor-auth-modal__button"
              label={"Zaloguj do zakładki “Sukcesja”"}
              styleType="primary"
              type="submit"
              onClick={() => null}
            />
          </Form>
        )}
      </Formik>
    </AuthModal>
  );
};

export default Login;
